import { Card, Table, Text } from "@radix-ui/themes";
import React, { useMemo } from 'react';
import { Controller, useWatch } from "react-hook-form";
import CheckboxComponent from "../../components/inputs/Checkbox/CheckboxComponent";
import TextFieldComponent from "../../components/inputs/Textfield/TextfieldComponent";
import { AssessmentType } from "../../types/Assessment";
import { StudentClassType } from '../../types/Student';
import { stringToBoolean } from "../../utils/utilities";

interface StudentGradesFormProps {
  students: Array<StudentClassType>;
  assessment: AssessmentType;
  control: any;
  errors: any;
  setValue?: any;
  getValues?: any;
  watch?: any;
  readonly?: boolean;
}

export const StudentGradesV2Form: React.FC<StudentGradesFormProps> = ({ students, assessment, control, errors, setValue, getValues, readonly, watch }) => {

  const handleCheckBoxSelectAll = (checked: boolean) => {
    students.map((item, studentIndex) => {
      setValue(`studentAssessment.${studentIndex}.assessment.isPublished`, checked)
    });
  }

  const isBlockedValues = useWatch({
    control,
    name: 'studentAssessment',
  });

  const isBlockedArray: boolean[] = useMemo(() => {
    return students.map((_, index) => {
      const blocked = isBlockedValues?.[index]?.assessment?.isBlocked;
      return stringToBoolean(blocked);
    });
  }, [isBlockedValues, students]);

  return (
    <Card>
      <Table.Root>
        <Table.Header>
          <Table.Row>
            <Table.ColumnHeaderCell>Nome</Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell>{assessment.type}</Table.ColumnHeaderCell>

            {control &&
              <Table.ColumnHeaderCell>
                <CheckboxComponent
                  name='selectAll'
                  label='Publicar todos?'
                  control={control || undefined}
                  errors={errors || {}}
                  onChange={handleCheckBoxSelectAll}
                />

              </Table.ColumnHeaderCell>

            }

          </Table.Row>
        </Table.Header>
        <Table.Body>
          {students?.map((student, studentIndex) => {
            const isBlocked = isBlockedArray[studentIndex];
            return (
              <Table.Row key={student.idStudent}>
                <Table.Cell>
                  <Text weight="bold">{student.student}</Text>
                </Table.Cell>
                <Table.Cell>
                  <TextFieldComponent
                    label=""
                    control={control}
                    errors={errors}
                    composedName={{ parent: `studentAssessment.${studentIndex}.assessment`, prop: 'grade' }}
                    name={`studentAssessment.${studentIndex}.assessment.grade`}
                    fieldProps={{ disabled: isBlocked }}
                  />
                  {errors?.studentAssessment?.[studentIndex]?.assessment.grade && (
                    <Text color="red" size="1">{`${errors?.studentAssessment?.[studentIndex]?.assessment?.grade?.message}`}</Text>
                  )}

                  <Controller
                    control={control}
                    name={`studentAssessment.${studentIndex}.assessment.idAssessment`}
                    defaultValue={assessment.id}
                    render={({ field }) => <input type="hidden" {...field} />}
                  />
                  <Controller
                    control={control}
                    name={`studentAssessment.${studentIndex}.assessment.status`}
                    defaultValue={true}
                    render={({ field }) => <input type="hidden" {...field} />}
                  />
                  <Controller
                    control={control}
                    name={`studentAssessment.${studentIndex}.assessment.id`}
                    defaultValue={student.idStudent}
                    render={({ field }) => <input type="hidden" {...field} />}
                  />
                </Table.Cell>
                <Table.Cell>
                  <CheckboxComponent
                    name={`studentAssessment.${studentIndex}.assessment.isPublished`}
                    label="Publicar?"
                    control={control}
                    errors={errors}
                    onChange={(checked) => {
                      console.log(`Checkbox do estudante ${student.student} mudou para:`, checked);
                    }}
                  //  disabled={getValues(`studentAssessment.${studentIndex}.assessment.isBlocked`)} 
                  />
                  {errors?.studentAssessment?.[studentIndex]?.assessment.isPublished && (
                    <Text color="red" size="1">{`${errors?.studentAssessment?.[studentIndex]?.assessment?.isPublished?.message}`}</Text>
                  )}

                </Table.Cell>

              </Table.Row>
            );
          })}
        </Table.Body>
      </Table.Root>
    </Card>
  );
};